'use strict';
import {MappingTablesCache} from "../../mappingTablesCache/mappingTablesCache.service";

const indexOf = require('lodash/indexOf');
const getValue = require('lodash/get');
const cloneDeep = require('lodash/cloneDeep');
var angular: angular.IAngularStatic = require('angular');

import {Component, Inject, Input, Output, EventEmitter, bundle, AfterViewInit, getInjectableName as gI} from 'ng-metadata/core';

import {BriefResultService} from './briefResult.service';
import {UpFrontActionsService} from './upFrontActions.service';
import {SearchService} from '../search.service';
import {SearchStateService} from '../searchState.service';
import {ResultUtil} from '../../nddUtils/resultUtil.service';
import {UserSessionManagerService} from '../../security/userSessionManager.service';
import {FacetService} from '../facet/facet.service';
import {TemplateUtil} from '../../nddUtils/templateUtil.service';
import {FavoritesService} from '../../favorites/favorites.service';
import {
    getEnableEmailClient,
    getResultsBulkSize,
    getSEOParamsMapping,
    getSEOParamsMappingParam,
    getSuspendWatchersActivatedForBrowser, isEnabledAsyncBriefResultDelivery
} from '../../appConfig/appConfigForward';
import {PrimolyticsService, beacon} from '../../analytics/primolytics.service';
import {JwtUtilService} from '../../security/jwtUtil.service';
import {PnxUtil} from '../../nddUtils/pnxUtil.service';
import {MediaQueries} from '../../infra/mediaQueries.service';
import {STATE_NAMES} from '../../primoExplore/primoExploreStates.module';
import {isBrowserIE} from '../../infra/browserSniffer';
//We inject this service only to fix a bug with mdToast which screws up mdDialog
import {AddQueryToSavedSearchesService} from '../savedQueries/addQueryToSavedSearches/addQueryToSavedSearches.service'
import {ActionListService} from "../actions/actionList.service";
import {ConfigurationUtil} from "../../nddUtils/configurationUtil.service";
import {StorageUtil} from "../../infra/storageUtil.service";
import {preventStateReload} from "../../infra/annotations";
import {CollectionDiscoveryService} from "../../collectionDiscovery/collectionDiscovery.service";
import {getVid, getInstitutionCode, isNgrsSearch} from "../../appConfig/appConfigForward";
import {FullViewModuleLoaderService} from "../fullView/fullViewModuleLoader.service";
import {DatabasesService} from "../../journals/databases.service";
import {getAttributesMap} from '../../appConfig/appConfigForward';
import {ServiceDetailsService} from '../../search/fullView/details/serviceDetails.service';
import {
    PersonalizeResultsButtonService
} from "../personalization/personalizationButton/personalizeResultsButton.service";
import {QuickLink} from "../../search/quickLink/quickLink.service";
import {StringUtils} from "../../nddUtils/stringUtils.service";
import {MoreLikeThisService} from "../moreLikeThis/moreLikeThis.service";
import {FullViewDialogService} from "../fullView/fullViewDialog.service";
import {FullViewPageService} from "../fullView/fullViewPage/fullViewPage.service";
import {AnalyticsUtils} from "../../nddUtils/analyticsUtils.service";
import { AuthoritySearchService } from "../authority/authoritySearch.service";

const get = require('lodash/get');
const some = require('lodash/some');
const _escape = require('lodash/escape');
const _throttle = require('lodash/throttle');


let dialogScope: ng.IScope;

@Component({
    selector: 'prm-brief-result-container',
    templateUrl: 'components/search/briefResult/briefResultContainer.html'
})


export class PrmBriefResultContainer {
    private showItemType: boolean;
    private _isGenericRecord: boolean;
    private digestWhenInViewConfigured: boolean;
    private isAuthoritySearch: boolean = false;

    @Input() private index;
    @Input() private item;
    @Input() public displayMode: string;
    @Input() private isDigestWhenInViewDisabled: boolean;

    @Input() private isExpanded;
    @Input() private isfavorites;
    @Input() private isFavoriteForDisplayFrbr;
    @Input() private itemHeight;
    @Input() private links;
    @Input() private isOverlayFullView: boolean;
    @Input() isFullView: boolean;
    @Input() dialogInView: boolean;
    @Input() private isTheHighlightedRecordYouCameFrom: boolean = false;
    @Output() private expandItemEvent = new EventEmitter<Object>();
    @Output() private showDialogEvent = new EventEmitter<Object>();
    @Output() private hideDialogEvent = new EventEmitter<Object>();
    @Output() loadNextResultsEvent = new EventEmitter<void>();
    @Output() loadPrevResultsEvent = new EventEmitter<void>();
    @Output() loadEmailTemplateEvent = new EventEmitter<void>();
    private isExpanded2 = false;
    private isExpanded3 = false;
    private KEY_CODE = {
        COMMA: 188,
        SEMICOLON: 186,
        ENTER: 13,
        ESCAPE: 27,
        SPACE: 32,
        PAGE_UP: 33,
        PAGE_DOWN: 34,
        END: 35,
        HOME: 36,
        LEFT_ARROW: 37,
        UP_ARROW: 38,
        RIGHT_ARROW: 39,
        DOWN_ARROW: 40,
        TAB: 9,
        BACKSPACE: 8,
        DELETE: 46
    };

    private vid = getVid();
    private institutionCode = getInstitutionCode();
    private originator: string;

    private showTimer = false;
    private _descriptions: string[] = [];

    /*Actions which open a new window must be set in this object so that the window can be opened as an immediate result to the click on the up-front actions and actions list.
     Otherwise the popup blocker will prevent the window from opening*/
    onToggle = {
        'Print': (item) => {
            this.printItemService.printItemAction(item)
        },
        'RefWorks': (item) => {
            this.refWorksService.refworksAction(item)
        },
        'EasyBib': (item) => {
            this.easyBibService.easyBibAction(item)
        },
        'EndNote': (item) => {
            this.endNoteService.endNoteAction(item)
        },
        'Mendeley': (item) => {
            this.mendeleyService.mendeleyAction(item)
        },
    };

    public actionLabelNamesMap;
    private _collectionDiscoveryData: { type; collectionId; institution };
    private isCollectionDiscoveryCollection: boolean;
    private loadShowActionsOptionsText: string;
    private loadCloseActionsOptionsText: string;

    /*private resultOffset = 0;*/
    private deliveryPromise: angular.IPromise<void>;
    private handleDetailsThrottled: any;
    private warningAttributes: string[] = [];
    private regularArttributes: string[] = [];

    constructor(private briefResultService: BriefResultService,
                private upFrontActionsService: UpFrontActionsService,
                @Inject('$mdDialog') private $mdDialog: angular.material.IDialogService,
                private resultUtil: ResultUtil,
                @Inject('featuredActionsIcons') private actionsIcons,
                private searchService: SearchService,
                private searchStateService: SearchStateService,
                private userSessionManagerService: UserSessionManagerService,
                @Inject('$location') private $location: ng.ILocationService,
                @Inject('$scope') private $scope: ng.IScope,
                private templateUtil: TemplateUtil,
                private jwtUtilService: JwtUtilService,
                private facetService: FacetService,
                @Inject('$state') private $state: angular.ui.IStateService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                private favoritesService: FavoritesService,
                private pnxUtil: PnxUtil,
                private primolyticsService: PrimolyticsService,
                private mediaQueries: MediaQueries,
                @Inject('$window') private $window: ng.IWindowService,
                private addQueryToSavedSearchesService: AddQueryToSavedSearchesService,
                @Inject('$mdToast') private $mdToast: ng.material.IToastService,
                @Inject('$element') private $element: ng.IRootElementService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                private actionListService: ActionListService,
                private configurationUtil: ConfigurationUtil,
                private storageUtil: StorageUtil,
                private collectionDiscoveryService: CollectionDiscoveryService,
                @Inject('restBaseURLs') private restBaseURLs: Object,
                private fullViewModuleLoaderService: FullViewModuleLoaderService,
                private databasesService: DatabasesService,
                private mappingTablesCache: MappingTablesCache,
                private serviceDetailsService: ServiceDetailsService,
                private quickLinkService: QuickLink,
                @Inject('$q') private $q: ng.IQService,
                private moreLikeThisService: MoreLikeThisService,
                private stringUtils: StringUtils,
                private fullViewDialogService: FullViewDialogService,
                private fullViewPageService: FullViewPageService,
                private analyticsUtils: AnalyticsUtils,
                private authoritySearchService: AuthoritySearchService) {

        this.handleDetailsThrottled = _throttle(this.handleDetails, 3000, {'trailing': false});
        /*this.resultOffset= Number(this.$state.params['offset'] | 0);*/

        $translate(['eshelf.send_to.tooltip', 'eshelf.close_send_to.tooltip']).then((translations) => {
            this.loadShowActionsOptionsText = translations['eshelf.send_to.tooltip'];
            this.loadCloseActionsOptionsText = translations['eshelf.close_send_to.tooltip'];
        });

        this.$timeout(() => {
            this.showTimer = true;

            // If we are on the last loaded index which need to show actions menu
            if (this.favoritesService.getItems().length === this.index) {
                this.briefResultService.actionsLoadingFinished = true;
            }
        }, 2000);

        this.$mdDialog = $mdDialog;
        this.jwtUtilService = jwtUtilService;
        this.briefResultService.isInGetFrbrEvent = false;
        this.showItemType = !this.isServicesPageState();
        $scope.$watch(() => this.isExpanded, (newValue) => {
            if (this.isExpanded2 !== newValue) {
                this.$timeout(() => this.isExpanded2 = newValue, 10);
                this.$timeout(() => this.isExpanded3 = newValue, 20);
            }
        });
        this.digestWhenInViewConfigured = (getSuspendWatchersActivatedForBrowser() === "ALL") || (getSuspendWatchersActivatedForBrowser() === "IE" && isBrowserIE());
        this.isAuthoritySearch = this.authoritySearchService.isAuthorityState();
    }

    ngOnInit() {
        if (this.isExpanded) {
            this.expandItemEvent.emit(false);
        }
        this._isGenericRecord = this.isGenericRecord();

        this.actionLabelNamesMap = {
            'E-mail': 'email',
            'Citation': 'citation',
            'Permalink': ((this.isServicesPage()) ? 'link' : 'permalink'),
            'Print': 'print',
            'EndNote': 'pushto.option.EndNote',
            'EasyBib': 'pushto.option.EasyBib',
            'RefWorks': 'pushto.option.RefWorks',
            'RISPushTo': 'pushto.option.RISPushTo',
            'BibTeXPushTo': 'pushto.option.BibTeXPushTo',
            'Mendeley': 'pushto.option.Mendeley',
            'Excel': 'pushto.option.Excel',
            'QR': 'pushto.option.qr',
            'Share': 'pushto.option.share'
        };
        this.index = this.index ? this.index : this.briefResultService.currentFullViewIndex;

        if (this.collectionDiscoveryService.isCollectionDiscoverySpecificDisplay) {
            this.isCollectionDiscoveryCollection = this.collectionDiscoveryData && (this.collectionDiscoveryData.type === 'COLLECTION' || this.collectionDiscoveryData.type === 'TOPCOLLECTION');
        }

        this.$scope.$watch(() => this.isExpanded, (newVal, oldVal) => {
            this.$timeout(() => {
                this.unfocusActionButtons('md-nav-bar button');
                this.unfocusActionButtons('md-nav-bar nav');
            }, 400);
        });

        this.$timeout(() => {
            this.removeRoleAtt();
        }, 0);

        this.parseDescriptions();
        this.getItemsCdiAttributes();

    }

    ngAfterViewInit() {
        this.loadEmailTemplateEvent.emit();
    }

    getText() {
        return this.item.display.source.title;
    }

    private getTextFromVal(value) {
        return this.serviceDetailsService.getTextFromVal(value);
    }

    private isSubfieldExist(value, subfield) {
        return this.serviceDetailsService.isSubfieldExist(value, subfield);
    }

    private getPrefix(value) {
        return this.serviceDetailsService.getPrefix(value);
    }

    private parseValue(value) {
        return this.serviceDetailsService.parseValue(value);
    }

    get descriptions() {
        this.$scope.$$watchers
        return this._descriptions;
    }

    public parseDescriptions() {
        let itemDescriptions = getValue(this.item, 'pnx.display.description', []);
        let promiseArray = itemDescriptions.map(value => this.parseValue(value));
        this.$q.all(promiseArray).then(parsedDescriptions => {
            this._descriptions = parsedDescriptions.map(value => {
                if (value && this.isSubfieldExist(value, '$$C')) {
                    return this.getPrefix(value) + this.getTextFromVal(value);
                }
                return this.getTextFromVal(value);
            });
        });

    }

    isFrbr() {
        return this.resultUtil.isFrbr(this.item);
    }

    newMetalibItem() {
        let context = getValue(this.item, 'context', false);
        let isMetaLib = context && context === 'MetaLib';
        let isNew = getValue(this.item, 'pnx.ranking.booster2[0]', false);
        let recId = getValue(this.item, 'pnx.control.recordid[0]', '');
        let alreadyDisplayedAsNew = getValue(this.getSearchObject(), 'metalibMoreStatus[' + recId + ']', 0) > 1;
        return isMetaLib && isNew && isNew === '1' && !alreadyDisplayedAsNew;

    }

    public getSearchObject() {
        return this.searchStateService.getSearchObject();
    }

    public isMultipleVersions() {
        return this.resultUtil.displayMultipleVersions(this.item, this.briefResultService.getSearchObject());
    }

    getResourceTypeForDisplay() {
        if(this.isAuthoritySearch){
            return  'nui.authority.type.' + this.item.pnx.display.authority_type[0];
        }
        return (this.isMultipleVersions() && !this.isFavoriteState() && !this.isPc() && this.searchService.getFrbrDisplay() === 1 ? 'mediatype.multiplever' : 'mediatype.' + this.item.pnx.display.type[0]);
    }

    private searchForRecordsSameSubject(){           
        this.briefResultService.performSearchRelatedBibs(this.item);    
       }

    isPc() {
        return this.item.context === 'PC';
    }

    isFrbrGeneric() {
        return this.resultUtil.isFrbr(this.item) && this.searchService.getFrbrDisplay() === 1;  //Generic Record   
    }

    isFrbrGenericNotPc() {
        return this.resultUtil.isMultipleVersions(this.item) && this.briefResultService.isGenericRecord(this.item) 
            && this.searchService.getFrbrDisplay() === 1 && this.item.context !== 'PC'; 
    }


    //resets the tabs so that all of the tabs are closed when more actions is opened
    closeOpenTabs(evt) {
        evt.stopPropagation();
        this.selectedAction = 'none';
    }

    private openTab(evt, selectedAction) {
        if (selectedAction != 'Citation') {
            this.primolyticsService.doBeaconReport({
                'p': 'sendTo',
                'op': selectedAction
            }, this.item, this.primolyticsService.getTimestamp());
        }

        if (this.actionListService.onToggle[selectedAction]) {
            this.actionListService.onToggle[selectedAction](this.item);//if a callback is set in on toggle the call it (to overcome popup blocker). Otherwise action will be invoked via the specific action directive constructor
            if(selectedAction === 'E-mail' && getEnableEmailClient())
                return;
        }
        evt.stopPropagation();
        this.openItemMenu(evt);
        // this.selectedAction= 'none';
        // this.$scope.$digest(); //this is done in order to fire the watcher on selectedAction in actionList directive
        this.selectedAction = selectedAction;
    }

    openItemMenu(evt) {
        this.changeItemMenuVisibility(evt, false);
    }

    // open item secondary menu
    toggleItemMenu(evt) {
        evt.stopPropagation();
        console.log(evt);
        this.changeItemMenuVisibility(evt, true);
    }


    private changeItemMenuVisibility(evt, isToggle) {
        if (!this.isExpanded) {
            this.closeOpenTabs(evt);
            this.expandItemEvent.emit({expand: true, target: this.$element[0]});
        } else if (isToggle) {
            this.expandItemEvent.emit({expand: false, target: this.$element[0]});
        }

    }

    private getLessMoreOptionsButtonText() {
        if (this.isExpanded) {
            return this.loadCloseActionsOptionsText;
        }
        return this.loadShowActionsOptionsText;
    }

    private getLessMoreOptionsButtonAriaLabel() {
        if (!this.$translate.isReady()) {
            return undefined;
        }
        const label = this.isExpanded ? 'nui.aria.close.actions.options' : 'nui.aria.show.actions.options';
        return this.stringUtils.decode(
            this.$translate.instant(label, {title: this.getRecordTitle()})
        );
    }

    public detectMobile() {
        if (this.mediaQueries.xs || this.mediaQueries.sm) {
            return true;
        }
        return false;
    }

    private isGenericRecord(record?) {
        if (this.isFavoriteState()) {
            return false;
        }
        if (!record && this._isGenericRecord !== undefined) {
            return this._isGenericRecord;
        }
        let item = record ? record : this.item;
        let isGeneric = false;
        if (this.briefResultService.getSearchObject().facets) {
            let facetNames = this.briefResultService.getSearchObject().facets.map((facet, index, arr) => facet.name);
            isGeneric = (this.resultUtil.isMultipleVersions(item) &&
                (facetNames.indexOf('frbrgroupid') === -1) && this.searchService.getFrbrDisplay() === 1); //Generic Record
        }
        return isGeneric;
    }

    get collectionDiscoveryData(): { type; collectionId; institution } {
        if (!this._collectionDiscoveryData && this.collectionDiscoveryService.isCollectionDiscoverySpecificDisplay) {
            this._collectionDiscoveryData = getValue(this.collectionDiscoveryService.getDataFromCollectionRecord(this.item), '[0]'); //parse the control.colldiscovery field in the pnx
        }
        return this._collectionDiscoveryData;
    }

    public isItemDeleted() {
        return (this.item.status === 'deleted');
    }

    private async handleDetails(item, event, callBeacon) { //serviceId is the id of the service we want to focus on when we open the full view dialog

        if (item) {
            this.currentItem = item;
        }

        if (this.isTheHighlightedRecordYouCameFrom) {
            this.openYourSelectedRecordOverlay(event, item);
            return;
        }
        if (this.item.status === 'deleted') {return;}
        if (this.configurationUtil.isSuprima() && isEnabledAsyncBriefResultDelivery() && !this.item.delivery && !this.isAuthoritySearch) {
            this.item.rtaInProgress = true;
            if (!this.deliveryPromise) {
                this.deliveryPromise = this.searchService.getRecordDelivery([item.pnx.control.recordid[0]],
                    get(item, 'pnx.control.rapidosourcerecordid'), null, [item]);
            }
            await this.deliveryPromise;
            this.item.rtaInProgress = false;
        }

        //To open record in a new tab with Ctrl+Enter or Ctrl+left mouse click
        if (event.ctrlKey) {
            return;
        }

        if ( event.preventDefault && !this.isFullViewOverlayOpen && event.target.tagName.toLowerCase() !== 'a' ) {
            event.preventDefault();
        }

        if (this.item.delivery && this.item.delivery.cdUpdate) {
            this.item.pnx.control.colldiscovery = this.item.delivery.cdUpdate.colldiscovery;
            this.item.pnx.display.cdparentid = this.item.delivery.cdUpdate.cdparentid;
        }

        if (this.collectionDiscoveryService.isCollectionDiscoverySpecificDisplay) {
            this.isCollectionDiscoveryCollection = this.collectionDiscoveryData && (this.collectionDiscoveryData.type === 'COLLECTION' || this.collectionDiscoveryData.type === 'TOPCOLLECTION');
        }

        if (this.isCollectionDiscoveryCollection) {
            this.$state.go(STATE_NAMES.COLLECTION_DISCOVERY, {
                collectionId: this.collectionDiscoveryData.collectionId,
                inst: this.collectionDiscoveryData.institution,
                vid: getVid()
            });
            return;
        }
        var sel = getSelection().toString();
        if (sel) {
            return;
        }
        if (this.isFullView) { //if we are already in full view don't open the full view dialog
            return;
        }

        if (callBeacon) {
            this.handleDetailsOpenfullWithBeacon(item);
        } else {
            this.handleDetailsOpenfull(item, event); // in case like availability when the availability sends operation to beacon and no need for fullView too
        }

    }

    handleDetailsOpenfullWithBeacon(item) {
        this.delay(17000).then(any => {
            this.handlefullViewBeacon();
        });
        this.handleDetailsOpenfull(item);


    }

    async delay(ms: number) {
        await new Promise(resolve => setTimeout(() => resolve(), ms));
    }

    @beacon({'p': 'brief', 'op': 'openfull'})
    handlefullViewBeacon() {
    }

    handleDetailsOpenfull(item, event) { //serviceId is the id of the service we want to focus on when we open the full view dialog

        if (this.isEsploroRecord(item) && this.configurationUtil.getUseEsploroAssetPage()) {
            window.open(this.templateUtil.getFullDeepLinkAbsPath(this.item), "_blank");
            return;
        }

        this.briefResultService.serviceId = 'brief';


        let target;
        if (event) {
            target = event.target;
            if (target && target.hasAttribute('prm-brief-internal-button-marker') ||
                target.classList.contains('prm-brief-internal-button-marker')) {
                return false;
            }

            this.briefResultService.serviceId = event.detail ? event.detail.index : event.index;
        }


        let showMore = this.isGenericRecord(item);

        if (showMore && !this.isPc()) {
            let facetString = 'frbrgroupid' + ',' + 'include' + ',' + this.pnxUtil.getValue(item, 'facets', 'frbrgroupid');
            this.facetService.frbrSearch({facet: facetString}, this.index);
            return;
        }


        this.$mdToast.hide();
        let loadFullViewAdditionalServices = {val: isBrowserIE() ? false : true};
        let dialogOpened = {val: false};
        let _this = this;
        this.fullViewModuleLoaderService.loadFullViewModule().then(() => {  //we need to wait for full view module to be loaded because we lazily load the chunk
            //change the url  to deep link url but don't trigger the ui router
            this.briefResultService.previousUrl = this.$location.url(); //save the url so you can restore it when dialog window is closed
            this.$location.url(this.templateUtil.getDeepLinkPath(item));

            this.favoritesService.needToChangeUrl = false;

            let dialog = this.$mdDialog;

            function dialogController($scope) {
                dialogScope = $scope;
                let vm = this;
                // vm.handleHide = ()=>{this.handleHideDetails()};
                vm.keydownSupport = keyDownSupport;
                vm.isFirstRecord = isFirstRecord;
                vm.isLastRecord = isLastRecord;
                vm.searchResults = searchResults;
                vm.getNextRecord = getNextRecord;
                vm.getPreviousRecord = getPreviousRecord;
                vm.currentResultIndex = currentResultIndex;
                vm.getNextRecordWithBeacon = getNextRecordWithBeacon;
                vm.getPrevRecordWithBeacon = getPrevRecordWithBeacon;
                vm.currentStateResults = currentStateResults;
                vm.isLastRecordByState = isLastRecordByState;
                vm.getAnalyticsPayload = getAnalyticsPayload;
                vm.sendAnalytics = sendAnalytics;



                //return focus on chosen element after closing dialog (full view overlay) with ESCAPE key
                function keyDownSupport(e) {
                    if (e.keyCode === this.KEY_CODE.ESCAPE) {
                        e.preventDefault();
                        this.handleHideDetails();
                        this.$timeout(() => {
                            return document.getElementById('SEARCH_RESULT_RECORDID_' + this.item.pnx.control.recordid[0]).focus();
                        }, 0);
                    }
                }

                function currentStateResults() {
                    switch (this.$state.current.name) {
                        case STATE_NAMES.SEARCH:
                        case STATE_NAMES.FULL_DISPLAY:
                            return this.briefResultService.searchResults();
                            break;
                        case STATE_NAMES.FAVORITES:
                            return this.favoritesService.getItems();
                            break;
                        case STATE_NAMES.DB_SEARCH:
                            return this.briefResultService.searchResults();
                            break;
                        case STATE_NAMES.JOURNAL_SEARCH:
                        case STATE_NAMES.JOURNAL_SEARCHJOURNAL_FULL_DISPLAY:
                            return this.briefResultService.searchResults();
                            break;
                        case STATE_NAMES.NEWSPAPERS:
                            return this.briefResultService.searchResults();
                            break;
                        case STATE_NAMES.CITATION_TRAILS:
                            return this.briefResultService.searchResults();
                            break;
                        case STATE_NAMES.CITATION_CHAPTERS:
                            return this.briefResultService.searchResults();
                            break;
                        case STATE_NAMES.ORGANIZATION_LIST:
                            return this.briefResultService.searchResults();
                            break;
                        case STATE_NAMES.AUTHORITY_SEARCH:
                        case STATE_NAMES.AUTHORITY_FULL_DISPLAY:
                            return this.briefResultService.searchResults();
                            break;
                        default:
                            return this.briefResultService.searchResults();
                    }
                }

                function isLastRecordByState() {
                    switch (this.$state.current.name) {
                        case STATE_NAMES.SEARCH:
                            return this.briefResultService.isLastRecord();
                            break;

                        case STATE_NAMES.FAVORITES:
                            return this.briefResultService.isLastRecordFav();
                            break;

                        case STATE_NAMES.DB_SEARCH:
                            return this.briefResultService.isLastRecord();
                            break;

                        case STATE_NAMES.JOURNAL_SEARCH:
                            return this.briefResultService.isLastRecord();
                            break;

                        case STATE_NAMES.NEWSPAPERS:
                            return this.briefResultService.isLastRecord();
                            break;

                        case STATE_NAMES.CITATION_TRAILS:
                            return this.briefResultService.isLastRecord();
                            break;

                        case STATE_NAMES.CITATION_CHAPTERS:
                            return this.briefResultService.isLastRecord();
                            break;

                        case STATE_NAMES.ORGANIZATION_LIST:
                            return this.briefResultService.isLastRecord();
                            break;

                        case STATE_NAMES.AUTHORITY_SEARCH:
                        case STATE_NAMES.AUTHORITY_FULL_DISPLAY:
                            return this.briefResultService.isLastRecord();
                            break;
                    }
                }

                function isFirstRecord() {
                    return this.briefResultService.isFirstRecord();
                }

                function isLastRecord() {
                    return this.briefResultService.isLastRecord();
                }

                function searchResults() {
                    return this.briefResultService.searchResults();
                }

                function currentResultIndex() {

                    switch (this.$state.current.name) {
                        case STATE_NAMES.FAVORITES:
                        case STATE_NAMES.ORGANIZATION_LIST:
                            return this.briefResultService.currentResultIndex(false);
                            break;
                    }
                    /* check if new pagination is enabled */
                    if (!this.resultUtil.isResultsPerPageEnabled()) {
                        return this.briefResultService.currentResultIndex(false);
                    }

                    /* check if remote */
                    let firstRecord = this.briefResultService.searchResults()[0];
                    let replaceResults = get(firstRecord, 'context') != 'MetaLib';
                    if (!replaceResults) {
                        return this.briefResultService.currentResultIndex(false);
                    }

                    let bulkSize = this.resultUtil.updatedBulkSize;

                    return this.briefResultService.currentResultIndex(true) % bulkSize;
                }

                function getNextRecordWithBeacon() {
                    if (this.briefResultService.isLastResultInCurrentBulk()) {
                        this.primolyticsService.doBeaconReport({
                            'p': 'brief',
                            'op': 'next'
                        }, this.item, this.primolyticsService.getTimestamp());
                    }
                    this.primolyticsService.doBeaconReport({
                        'p': 'brief',
                        'op': 'nextResult'
                    }, this.item, this.primolyticsService.getTimestamp());
                }

                function getPrevRecordWithBeacon() {
                    this.primolyticsService.doBeaconReport({
                        'p': 'brief',
                        'op': 'previousResult'
                    }, this.item, this.primolyticsService.getTimestamp());
                }

                function getNextRecord() {
                    this.originator = 'nextRecord';
                    this.getNextRecordWithBeacon();

                    switch (this.$state.current.name) {
                        case STATE_NAMES.SEARCH:
                            /* check if remote */
                            let firstRecord = this.briefResultService.searchResults()[0];
                            let replaceResults = this.resultUtil.isResultsPerPageEnabled() && firstRecord.context != 'MetaLib';

                            this.briefResultService.getNextRecord(replaceResults).then(data => {

                                let currentIndex = this.briefResultService.getIndex(replaceResults, data);
                                this.item = this.briefResultService.searchResults()[currentIndex];
                                this.briefResultService.changeFullDisplayUrl(this.item);
                            })
                            break;

                        case STATE_NAMES.FAVORITES:
                            let currentIndex = this.briefResultService.getNextRecordFav();
                            this.item = this.favoritesService.getItems()[currentIndex];
                            this.briefResultService.changeFullDisplayUrl(this.item);
                            break;

                        case STATE_NAMES.DB_SEARCH:
                            this.briefResultService.getNextRecord(true).then(data => {
                                let currentIndex = this.briefResultService.getIndex(true, data);
                                this.item = this.briefResultService.searchResults()[currentIndex];
                                this.briefResultService.changeFullDisplayUrl(this.item);
                            })
                            break;

                        case STATE_NAMES.JOURNAL_SEARCH:
                            this.briefResultService.getNextRecord(true).then(data => {
                                let currentIndex = this.briefResultService.getIndex(true, data);
                                this.item = this.briefResultService.searchResults()[currentIndex];
                                this.briefResultService.changeFullDisplayUrl(this.item);
                            })
                            break;

                        case STATE_NAMES.NEWSPAPERS:
                            this.briefResultService.getNextRecord(true).then(data => {
                                let currentIndex = this.briefResultService.getIndex(true, data);
                                this.item = this.briefResultService.searchResults()[currentIndex];
                                this.briefResultService.changeFullDisplayUrl(this.item);
                            })
                            break;

                        case STATE_NAMES.CITATION_TRAILS:
                            this.briefResultService.getNextRecord(true).then(data => {
                                let currentIndex = this.briefResultService.getIndex(true, data);
                                this.item = this.briefResultService.searchResults()[currentIndex];
                                this.briefResultService.changeFullDisplayUrl(this.item);
                            })
                            break;

                        case STATE_NAMES.CITATION_CHAPTERS:
                            this.briefResultService.getNextRecord(true).then(data => {
                                let currentIndex = this.briefResultService.getIndex(true, data);
                                this.item = this.briefResultService.searchResults()[currentIndex];
                                this.briefResultService.changeFullDisplayUrl(this.item);
                            })
                            break;

                        case STATE_NAMES.ORGANIZATION_LIST:
                            this.briefResultService.getNextRecord().then(data => {
                                let currentIndex = data;
                                this.item = this.briefResultService.searchResults()[currentIndex];
                                this.briefResultService.changeFullDisplayUrl(this.item);
                            })
                            break;
                        default:
                            this.briefResultService.getNextRecord(true).then(data => {
                                let currentIndex = this.briefResultService.getIndex(true, data);
                                this.item = this.briefResultService.searchResults()[currentIndex];
                                this.briefResultService.changeFullDisplayUrl(this.item);
                            })
                    }

                }

                function getAnalyticsPayload() {
                    return {
                        'Pagination Type': 'Record',
                        'Record Title' : get(this.item, 'pnx.display.title[0]'),
                        "Resource Type": get(this.item, 'pnx.display.type[0]'),
                        "Record ID": get(this.item, 'pnx.control.recordid[0]')
                    }
                }
                function sendAnalytics() {
                    let payload = this.getAnalyticsPayload();
                    this.analyticsUtils.trackUsage(this.analyticsUtils.eventsNames.PAGINATION, payload);
                }



                function getPreviousRecord() {
                    this.originator = 'previousRecord';
                    this.getPrevRecordWithBeacon();

                    switch (this.$state.current.name) {
                        case STATE_NAMES.FAVORITES:
                        case STATE_NAMES.ORGANIZATION_LIST:
                            this.briefResultService.getPreviousRecord().then(data => {
                                let currentIndex = data;
                                this.item = this.briefResultService.searchResults()[currentIndex];
                                this.briefResultService.changeFullDisplayUrl(this.item);
                            })
                            break;
                        default:
                            /* check if remote */
                            let firstRecord = this.briefResultService.searchResults()[0];
                            let replaceResults = this.resultUtil.isResultsPerPageEnabled() && firstRecord.context != 'MetaLib';

                            this.briefResultService.getPreviousRecord(replaceResults).then(data => {
                                let currentIndex = this.briefResultService.getIndex(replaceResults, data);
                                this.item = this.briefResultService.searchResults()[currentIndex];
                                this.briefResultService.changeFullDisplayUrl(this.item);
                            })
                    }

                }
            };

            dialogController.$inject = ['$scope'];
            if (document.querySelector('.md-dialog-container')) {
                this.dialogLoaded(loadFullViewAdditionalServices, dialogOpened);

            } else {
                dialog.show({
                    onComplete: () => {
                        this.dialogLoaded(loadFullViewAdditionalServices, dialogOpened);
                    },
                    onRemoving: () => {
                        this.handleHideDetails();
                    },
                    templateUrl: 'components/search/fullView/full-view-dialog-template.html',
                    locals: {
                        getFocusId: () => this.briefResultService.serviceId,
                        item: item,
                        $location: this.$location,
                        $timeout: this.$timeout,
                        perviousUrl: this.previousUrl,
                        $state: this.$state,
                        jwtUtilService: this.jwtUtilService,
                        mediaQueries: this.mediaQueries,
                        isfavorites: this.isfavorites,
                        loadFullViewAdditionalServices: loadFullViewAdditionalServices,
                        dialogOpened: dialogOpened,
                        $mdDialog: this.$mdDialog,
                        KEY_CODE: this.KEY_CODE,
                        searchService: this.searchService,
                        briefResultService: this.briefResultService,
                        resultUtil: this.resultUtil,
                        favoritesService: this.favoritesService,
                        primolyticsService: this.primolyticsService,
                        analyticsUtils: this.analyticsUtils,
                        handleHideDetails: (item) => {
                            this.handleHideDetails(item);
                        },
                        dialogRemoved: this.dialogRemoved,
                        originator: this.originator
                    },
                    bindToController: true,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    escapeToClose: true,
                    focusOnOpen: false, // we will handle focus ourselves since it doesnt seem to work in md
                    controller: dialogController,
                    controllerAs: '$ctrl'
                });

            }

            let listener;
            let backListener;
            listener = this.$scope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams) => {

                let fullDispalysMap = {
                    '/fulldisplay': ['/search', '/favorites', '/chapters'],
                    '/jfulldisplay': ['/jsearch'],
                    '/npfulldisplay': ['/npsearch'],
                    '/dbfulldisplay': ['/dbsearch'],
                    '/authfulldisplay': ['/authsearch']
                }

                event.preventDefault();
                listener();
                listener = this.$scope.$on('$locationChangeStart', (event) => {
                    event.preventDefault();
                    listener();	//this unregisters the event listener so we can revert to previous url once dialog is closed
                });
                //This code is for handling the back browser button
                //We want the transition between full to search
                // to close the dialog
                backListener = this.$scope.$watch(() => {
                    return this.$location.path()
                }, (newLocation, oldLocation) => {

                    if (oldLocation && fullDispalysMap[oldLocation] && fullDispalysMap[oldLocation].indexOf(newLocation) > -1) {
                        if (!this.briefResultService.preventDialogClose) {
                            this.dialogRemoved();
                            backListener();
                            this.searchService.updatePageTitle();
                            this.searchService.updatePageDescription();
                        } else {
                            this.briefResultService.preventDialogClose = false;
                        }
                    }
                });
                window.onpopstate = () => {
                    window.onpopstate = undefined;
                    this.dialogRemoved();
                };
            });


        });
    }

    handleHideDetails(item) {
        item = item || this.item;

        if (this.digestWhenInViewConfigured) {
            this.hideDialogEvent.emit(false);
            dialogScope.$suspend();
        }

        if (window.appPerformance.serverTimeLog) {
            window.appPerformance.serverTimeLog['viewit'] = 0;
            window.appPerformance.serverTimeLog['pcDelivery'] = 0;
            window.appPerformance.serverTimeLog['getLocItems'] = 0;
            window.appPerformance.serverTimeLog['PhysicalServiceIdCalc'] = 0;
        }

        if (this.briefResultService.previousUrl) {
            this.dialogRemoved(item);
            this.briefResultService.handleDialogHide(this.briefResultService.previousUrl, item);

            if (document.querySelector('.md-dialog-container')) {
                angular.element(document.querySelector('.md-dialog-container')).addClass('fixed-container');
            }
        } else {
            this.$mdDialog.hide();
        }
        console.log('Remove title, decription and schema.org of closed item.');
        this.searchService.removeSEOData();
        angular.element(document.getElementById('email-template-full')).remove();
    }

    async getDisplayLines() {
        if (!this.item) {
            return [];
        }

        let pnxId = this.item.pnx.display.source;
        if (!this.lines || this.lastId !== pnxId) {
            this.lastId = pnxId;
            this.lines = await this.briefResultService.parseDisplayLines(this.item, this.isCollectionDiscoveryCollection);
        }
        return this.lines;
    }

    public async getTitle() {
        try {
            // Read title conf param
            let titlePath = getSEOParamsMappingParam('title');
            if (titlePath) {
                try {
                    return this.configurationUtil.jsonPathToValue(this.item, titlePath);
                } catch (e) {
                    console.log('Parse title error. Path is ' + titlePath + ' Item is: ');
                    console.log(this.item);
                    console.error(e);
                    return '';
                }
            }
            let title = await this.getDisplayLines();
            return title[0]['values'].filter(e => e.key == 'title').map(e => e.text)[0][0];
        } catch (e) {
            console.log('Parse title is corrupt');
            console.error(e);
            return '';
        }

    }

    dialogRemoved(item) {
        item = item || this.item;

        if (document.querySelector('.md-dialog-container')) {
            angular.element(document.querySelector('.md-dialog-container')).addClass('accessible-explore');
        }
        if (document.querySelector('md-backdrop')) {
            angular.element(document.querySelector('md-backdrop')).addClass('accessible-explore');
        }
        if (document.querySelector('.md-scroll-mask')) {
            angular.element(document.querySelector('.md-scroll-mask')).addClass('accessible-explore');
        }
        if (document.querySelectorAll('.full-view-navigation')) {
            angular.element(document.querySelectorAll('.full-view-navigation')).addClass('accessible-explore');
        }
        /*This is removeClass by purpose - not a mixup*/
        if (document.querySelectorAll('.prm-full-view-dialog')) {
            angular.element(document.querySelectorAll('.prm-full-view-dialog')).removeClass('_md-transition-in');
        }

        if (document.querySelectorAll('body')) {
            angular.element(document.querySelectorAll('body')).removeClass('md-dialog-is-showing');
            angular.element(document.querySelectorAll('body')).attr('style', '');
        }

        let recordId = get(item, 'pnx.control.recordid[0]');
        if (recordId) {
            let focusElem = document.getElementById('SEARCH_RESULT_RECORDID_' + recordId);
            if (focusElem) {
                focusElem.focus();
            }
        }
    }


    dialogLoaded(loadFullViewAdditionalServices, dialogOpened) {
        dialogScope.$ctrl.item = this.item;       // Be sure we are on the right current item

        if (this.digestWhenInViewConfigured) {
            this.showDialogEvent.emit(false);
            dialogScope.$resume();
        }
        if (document.querySelector('.md-dialog-container')) {
            angular.element(document.querySelector('.md-dialog-container')).removeClass('accessible-explore');
        }
        if (document.querySelector('md-backdrop')) {
            angular.element(document.querySelector('md-backdrop')).removeClass('accessible-explore');
        }
        if (document.querySelector('.md-scroll-mask')) {
            angular.element(document.querySelector('.md-scroll-mask')).removeClass('accessible-explore');
        }
        if (document.querySelectorAll('.full-view-navigation')) {
            angular.element(document.querySelectorAll('.full-view-navigation')).removeClass('accessible-explore');
        }

        /*This is addClass by purpose - not a mixup*/

        if (document.querySelectorAll('.prm-full-view-dialog')) {
            angular.element(document.querySelectorAll('.prm-full-view-dialog')).addClass('_md-transition-in');
        }
        if (document.querySelectorAll('body')) {
            angular.element(document.querySelectorAll('body')).addClass('md-dialog-is-showing');
            angular.element(document.querySelectorAll('body')).attr('style', 'position: fixed; width: 100%; top: 0px;');
        }

        this.briefResultService.isFullViewOverlayOpen = true;

        if (loadFullViewAdditionalServices.val) {
            dialogOpened.val = true;
        } else {
            this.$timeout(() => dialogOpened.val = true, 0);
            this.$timeout(() => loadFullViewAdditionalServices.val = true, 1000);
        }

        this.briefResultService.currentFullViewIndex = this.index ? this.index : 0;

        if (document.querySelector('.md-dialog-container')) {
            angular.element(document.querySelector('.md-dialog-container')).addClass('fixed-container');
        }

        let scrollElement = document.querySelector('sticky-scroll');
        if (scrollElement) {
            scrollElement.scrollTop = 0
        }
    }


    isFavoriteState() {
        if (this.$state.current.name == STATE_NAMES.FAVORITES) {
            return true;
        }
        return false;
    }

    isSearchState() {
        return this.$state.current.name === STATE_NAMES.SEARCH;
    }

    isServicesPageState() {
        return this.briefResultService.isServicePageState();
    }

    get isQuickLinksAvailable() {
        return (this.quickLinkService.isQuickLinksAvailable(this.item));
    }

    get isUnpaywallLinksAvailable() {
        return (this.quickLinkService.isUnpaywallLinksAvailable([this.item]));
    }

    get isPeerDocument() {
        return (get(this.item, 'pnx.display.lds50[0]') === 'peer_reviewed');

    }

    get isOpenAccessDocument() {
        return (get(this.item, 'pnx.display.oa[0]') === 'free_for_read' || get(this.item, 'pnx.addata.openaccess[0]') === 'true');

    }

    get isCourseDocument() {
        let crsFields = this.moreLikeThisService.getDataFromCourseItem(this.item);
        let isAtLeastOneValidCourse = false;

        if (crsFields) {
            crsFields.forEach(element => {
                if (element.publicationStatus !== "DRAFT" && (element.courseInst === undefined || element.courseInst === getInstitutionCode())) {
                    isAtLeastOneValidCourse = true;
                }
            });
        }

        return isAtLeastOneValidCourse;
    }

    get isCdiAttributesDocument() {
        return (this.isCdiWarningAttributesDocument || this.isCdiRegulargAttributesDocument);
    }

    get isCdiWarningAttributesDocument() {
        return this.warningAttributes.length > 0;

    }

    get isCdiRegulargAttributesDocument() {
        return this.regularArttributes.length > 0;
    }

    public getItemsCdiAttributes() {
        let attributes: string[] = get(this.item, 'pnx.display.attribute');
        if (attributes) {
            this.removeDuplicates(attributes).forEach(element => {
                this.briefResultService.warningAttributesOrder.has(element) ? this.warningAttributes.push(element) : this.regularArttributes.push(element)
            });
        }
    }

    get warningCdiAttributesItem() {
        return this.warningAttributes.sort((a,b) => { return this.briefResultService.warningAttributesOrder.get(a) - this.briefResultService.warningAttributesOrder.get(b)});;
    }

    get regularCdiAttributesItem() {
        return this.regularArttributes.sort((a,b) => { return this.briefResultService.regularAttributesOrder.get(a) - this.briefResultService.regularAttributesOrder.get(b)});;
    }

    get isCdiAttributesEnabledInBO() {
        return this.briefResultService.isCdiAttributesEnabledInBO;
    }

    private removeDuplicates(arr) {
        let arrWithoutDuplicates: string[] = [];
        arr.forEach(element => {
            if (!arrWithoutDuplicates.includes(element)) {
                arrWithoutDuplicates.push(element);
            }
        });
        return arrWithoutDuplicates;
    }

    get isChosen() {
        return this.briefResultService.getIfChosenForRecordId(this.recordId);
    }

    set isChosen(isChosen) {
        //this.briefResultService.saveJsonOdIdsAndIfChosen(this.recordId, isChosen);
        this.briefResultService.saveJsonOdIdsAndIfChosen(this.recordId, isChosen);
        this.briefResultService.saveJsonOdIdsAndItems(this.item, isChosen);

    }

    get currentItem() {
        return this.fullViewPageService.currentItem;
    }

    set currentItem(item) {
        this.fullViewPageService.currentItem = item;
    }

    get upFrontActions() {
        if (this.configurationUtil.isSuprima()) {
            //display permalink for suPrima
            return this.upFrontActionsService.requiredUpFrontActionsList;
        }
        let frontActions = this.upFrontActionsService.requiredUpFrontActionsList.filter((action) =>
            !(this.item.context === 'Ebsco' && action === 'Permalink'));
        return frontActions;
    }

    getActionIconName(action) {
        return this.upFrontActionsService.getActionIconName(action);
    }

    getActionLabel(action) {
        return this.upFrontActionsService.getActionLabel(action);
    }

    get delivery() {
        return getValue(this.item, 'delivery');
    }

    get recordId() {
        if (this.item.status === 'deleted') {
            return this.item.favorite.recordId;
        }
        return this.item.pnx.control.recordid[0];
    }

    get resourceType() {
        return get(this.item, 'pnx.display.type[0]');
    }

    get recordTitle() {
        return get(this.item, 'pnx.display.title[0]');
    }

    public getDeepLinkPath() {
        if (this.isCollectionDiscoveryCollection) {
            return this.$state.href(STATE_NAMES.COLLECTION_DISCOVERY, {
                collectionId: this.collectionDiscoveryData.collectionId,
                inst: this.collectionDiscoveryData.institution,
                vid: getVid()
            });
        }
		if (this.item.status === 'deleted') {return '';}
        return this.templateUtil.getFullDeepLinkAbsPath(this.item);
    }

    public isShowCitationTrails() {
        let state = this.$state.current.name;
        return state === STATE_NAMES.CITATION_TRAILS || state === STATE_NAMES.SEARCH;
    }

    private keyDownSupport(e) {
        let keyCodes = this.KEY_CODE;

        if (e.keyCode === 27) {
            this.closeOpenTabs(e);
            this.toggleItemMenu(e);
        }
    }

    private focusOnXButton() {
        let closeButton = this.$element[0].querySelector('#briefResultMoreOptionsButton' + this.index);
        closeButton.focus();
    }

    getActionTranslate(actionName) {
        let label = 'fulldisplay.command.' + this.actionLabelNamesMap[actionName];
        return this.$translate.instant(label);
    }

    get isSuprima() {
        return this.configurationUtil.isSuprima();

    }

    public escapeString(str) {
        return _escape(str)
    }

    private getRecordTitle() {
        if (!this.item.pnx) {
            return;
        }
        return this.isAuthoritySearch ? this.item.pnx.display['heading'][0] : this.item.pnx.display['title'][0];
    }

    private getSelectRecordAriaLabel() {
        if (!this.$translate.isReady()) {
            return undefined;
        }
        return this.stringUtils.decode(
            this.$translate.instant('nui.aria.brief.select.title', {title: this.getRecordTitle()})
        );
    }


    private isServicesPage() {
        if (this.$state.current.name === 'servicesPage') {
            return true;
        }
        return false;
    }

    public getNameTitleParams(paramsKeys, action) {
        let myJson = {};
        myJson[paramsKeys[0]] = this.getActionTranslate(action);
        myJson[paramsKeys[1]] = this.getRecordTitle();
        return myJson;
        /*{
         name: this.getActionTranslate(action),
         title: this.getRecordTitle()
         }*/
    }

    public getUpFrontActionsTranslated(action) {
        return this.stringUtils.decode(this.$translate.instant('nui.aria.action.nameTitle', {
            name: this.getActionTranslate(action),
            title: this.getRecordTitle()
        }));
    }
    public getActionsTranslated() {
        return this.stringUtils.decode(this.$translate.instant('nui.aria.actionsFor', {
            title: this.getRecordTitle()
        }));
    }
    public ctoUrl() {
        let params;
        if (this.$state.current.name === 'servicesPage') {
            let location = this.$window.location.toString();
            let index = location.indexOf('?');
            params = location.substring(index + 1, location.length) + '&isServicesPage=true';
        } else {
            params = 'vid=' + this.vid;
        }
        return this.restBaseURLs.openUrl + '/' + this.institutionCode + '/dbg?' + params;
    }

    public displayCTOButton() {
        return this.configurationUtil.isSuprima() && this.$location.search()['displayCTO'] == 'true';
    }

    public getItme() {
        return JSON.stringify(this.item);
    }

    //this function remove tabindex=-1 from all li buttons so that they focused with Tab key when action list is open.
    //also, this function set role="list" attribute to the all actions list.
    private unfocusActionButtons(str) {
        let actionButtons: [Element] = this.$element[0].querySelectorAll(str);
        if (this.isExpanded && this.$element) {
            for (let li of actionButtons) {
                li.removeAttribute('tabindex');
            }
        }
    }

    private sendBriefBeacon() {
        if (!this.isSearchState()) {
            return;
        }
        let currOp = this.isChosen ? 'selectSingleRecord' : 'unselectSingleRecord';
        this.primolyticsService.doBeaconReport({
            'p': 'brief',
            'op': currOp
        }, this.item, this.primolyticsService.getTimestamp());
    }

    public isDBSearch() {
        return this.databasesService.isDBSearch();
    }

    get isFullViewOverlayOpen() {
        return this.briefResultService.isFullViewOverlayOpen;
    }

    get isToolBarEnabled() {
        return this.briefResultService.enableOrDisableToolBar;
    }

    private isBookRecordType() {
        /*return this.item.pnx.search.rsrctype['book'];*/
        return get(this.item, 'pnx.search.rsrctype[0]') === 'book';
    }

    private isBookChapterRecordType() {
        /*return this.item.pnx.search.rsrctype['book'];*/
        return get(this.item, 'pnx.search.rsrctype[0]') === 'book_chapter';
    }

    public hasRelatedItems() {
        /*
         /!* ****To remove after connection with Rest API **** *!/
         return false;
         /!* ****To remove after connection with Rest API  - End **** *!/
         */

        if (this.isSuprima) {
            return getAttributesMap()['relatedItemsActive'] == true;
        }
        if (!this.isBookRecordType() && !this.isBookChapterRecordType()) {
            return false;
        }
        return this.briefResultService.isRelatedItemsConfiguredPrimo(this.vid);
    }

    public isEmailMode() {
        return this.displayMode === 'email';
    }


    //This function remove "role" attribute from the main clickable div that ng-click added
    public removeRoleAtt() {
        let id = 'SEARCH_RESULT_RECORDID_' + this.recordId;
        // remove role from brief result container in brief results.
        let elem = document.getElementById(id);
        if (elem) {
            elem.removeAttribute('role');
        }
        // remove role from brief result container in full view.
        elem = document.getElementById(id + '_FULL_VIEW');
        if (elem) {
            elem.removeAttribute('role');
        }
    }


    public isNgrsSearch() {
        return isNgrsSearch();
    }

    public sendBeacon() {
        if (this.$state.current.name === STATE_NAMES.SEARCH && !this.$location.path().endsWith('/fulldisplay')) {
            this.runBriefIconBeaconCall();
        }
    }

    get disableDigest() {
        return this.isDigestWhenInViewDisabled || this.isExpanded;
    }

    @beacon({'p': 'brief', 'op': 'icon'})
    public runBriefIconBeaconCall(){}

    public sendAnalytics() {
        const eventToUse = this.isFrbrGenericNotPc() ? this.analyticsUtils.eventsNames.FRBR_LINK : this.analyticsUtils.eventsNames.DISPLAY_FULL_RECORD;
        const payload = this.getAnalyticsPayload(eventToUse);
        this.analyticsUtils.trackUsage(eventToUse,payload);
    }

    private getAnalyticsPayload(eventName) {
        let payload = {};
        switch (eventName) {
            case this.analyticsUtils.eventsNames.DISPLAY_FULL_RECORD:
                payload = {
                    "Clicked On": 'Brief Record',
                    "Resource Type": this.resourceType,
                    "Record Title": this.recordTitle,
                    "Record ID": this.recordId            
                }
                break;

                case this.analyticsUtils.eventsNames.FRBR_LINK:
                    payload = {
                        'Versions Count': get(this.item, 'pnx.display.version[0]'),
                        "Record Title": this.recordTitle,
                        'Resource Type': this.resourceType,
                        "Record ID": this.recordId  
                    }
                    break;
                
            default:
                break;
        }

        return payload;
    }

    private isEsploroRecord(item) {
        if (item &&
            item.pnx &&
            item.pnx.control &&
            item.pnx.control.sourceformat &&
            item.pnx.control.sourceformat.length > 0 &&
            item.pnx.control.sourceformat[0] === 'ESPLORO') {

            return true;
        }

        return false;
    }

    get isRapidoSAEnabled() {
        return this.configurationUtil.getRapidoSAEnabled()
    }

    public openYourSelectedRecordOverlay(event, yourSelectedRecordItem) {
        if (event.preventDefault) {
            event.preventDefault(); //do not open the href
        }
        this.openYourSelectedRecordItemFullView(event, yourSelectedRecordItem);
        return;
    }

    private openYourSelectedRecordItemFullView(event, yourSelectedRecordItem) {
        if (yourSelectedRecordItem) {
            this.fullViewDialogService.openFullViewDialog(yourSelectedRecordItem, event, this.searchService.YOUR_SELECTED_RECORD_ITEM);
        }
    }

    get isPresentAiInsightsLink() {
        return (this.quickLinkService.isPresentAiInsightsLink(this.item));
    }
}






// WEBPACK FOOTER //
// ./src/main/webapp/components/search/briefResult/briefResultContainer.directive.ts